document.addEventListener('DOMContentLoaded', function () {
    var backicon = document.querySelector('.ribon-back-icon');
    var backtext = document.querySelector('.ribon-back-text');

    if (backicon) {
        var params = new URLSearchParams(window.location.search);
        var email = params.get('email');
        // Preserve email across navigation so the login page can pre-fill it
        var loginUrl = email ? '/login?email=' + encodeURIComponent(email) +'&showpassword=true' : '/login?showpassword=true';

        backtext.addEventListener('click', function () {
            window.location.href = loginUrl;
        });
        backicon.addEventListener('click', function () {
            window.location.href = loginUrl;
        });
    }
});